<template>
  <div>
    <LoadingState v-if="!status.isLoaded" :size="50" />
    <div v-else>
      <PageTitle>
        <div class="mr-2">{{ allocation.hostname }}</div>
        <HorizontalList :items="headerItems()" />
        <template #actions>
          <DropDown :items="menuItems()">
            <Btn>{{ $t("global.actions") }}</Btn>
          </DropDown>
        </template>
      </PageTitle>
      <div class="row">
        <div class="col-lg-12 mb-4">
          <AllocationGraphsCard :allocation="allocation" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import AllocationGraphsCard from "@/components/smart/cards/AllocationGraphs";
import Btn from "@/components/display/Btn";
import { canWrite } from "@/utils/useAuth";
import ConfirmationModal from "@/components/display/ConfirmationModal";
import DropDown from "@/components/display/DropDown";
import { getStatusVariant } from "@/utils/statusVariant";
import HorizontalList from "@/components/display/HorizontalList";
import LoadingState from "@/components/display/LoadingState";
import NavLink from "@/classes/NavLink";
import PageTitle from "@/components/display/PageTitle";
import store from "@/store";

export default {
  name: "AllocationPage",
  components: {
    AllocationGraphsCard,
    Btn,
    DropDown,
    HorizontalList,
    LoadingState,
    PageTitle,
  },
  props: {
    allocationId: {
      type: [Number, String],
      required: true,
    },
  },
  setup(props, { root }) {
    const allocation = computed(() => store.state.allocations.item);
    const status = computed(() => store.state.allocations.status);

    const headerItems = () => [
      {
        key: root.$t("global.status"),
        value:
          allocation.value && allocation.value.status
            ? root.$t(`global.${allocation.value.status}`)
            : root.$t("global.na"),
        variant: getStatusVariant(allocation.value.status),
      },
    ];

    const confirmReboot = (allocation) => {
      store.dispatch("modals/open", {
        template: ConfirmationModal,
        data: {
          confirm: () => store.dispatch("allocations/reboot", allocation.id),
          errorMessage: root.$t("global.soft-reboot-problem", { name: allocation.hostname }),
          message: root.$t("global.soft-reboot-confirmation", { name: allocation.hostname }),
          title: root.$t("global.reboot"),
        },
      });
    };

    const menuItems = () => {
      const items = [];
      if (canWrite("services") && allocation.value.isRebootable) {
        items.push(
          new NavLink(
            root.$t("global.reboot"),
            null,
            () => confirmReboot(allocation.value),
            null,
            "danger"
          )
        );
      }

      return items.filter((i) => i !== null);
    };

    onMounted(() => {
      store.dispatch("allocations/get", props.allocationId);
    });

    return {
      allocation,
      headerItems,
      menuItems,
      status,
    };
  },
};
</script>
